import React from 'react';
import { SvgWithColorProps } from '../interfaces';

const SVGCardCross = ({ color }: SvgWithColorProps) => (
  <svg
    width='31'
    height='31'
    viewBox='0 0 31 31'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2.44531 3L27.9453 28.5M27.9453 3L2.44531 28.5'
      stroke={color}
      strokeOpacity='0.5'
      strokeWidth='6'
    />
  </svg>
);

export default SVGCardCross;
